/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var elements = document.getElementsByClassName('header__mobile-nav-toggle icon-state')

var myFunction = function() {
    //var attribute = this.getAttribute("data-myattribute");
  toggle_visibility("boost-pfs-filter-tree-mobile-button-stick-wrapper");
    console.log("hello world");
};

for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', myFunction, false);
}

function toggle_visibility(className) {
    elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++) {
        elements[i].style.display = elements[i].style.display == 'none' ? 'block' : 'none';
    }
}

document.addEventListener("DOMContentLoaded", function () {
  
  // Function to replace text and update buttons when elements are loaded
  function replaceSpecialOrderText() {
    // Find all elements with the class "snize-attribute"
    var elements = document.querySelectorAll(".snize-attribute");

    // Loop through each element
    elements.forEach(function (element) {
      var productItem = element.closest(".snize-product"); // Get the closest product item element
      var button = productItem.querySelector(".snize-button"); // Find the button inside the product item

      // Extract product ID from the list item's id attribute
      var productId = productItem.id.replace("snize-product-", "");

      // Check and replace text content
      if (element.textContent.trim() === "Special Order") {
        element.innerHTML = `
          <span style="color:#ff9900; font-size:14px; font-weight:500;">
            Special Order
            <br><small>Normally ships within three-six weeks.</small>
          </span>
        `;
        button.textContent = "Special Order"; // Update button text for special orders
        button.style.backgroundColor = "#00AA00";
        button.classList.remove("snize-add-to-cart-button");
      }
      if (element.textContent.trim() === "Pre-Order") {
        element.innerHTML = `
          <span style="color:#ff9900; font-size:14px; font-weight:500;">
            &#128197; Pre-Order
            <br><small>Release Date is Estimate Only</small>
          </span>
        `;
        button.textContent = "Pre-Order"; // Update button text for pre-orders
        button.style.backgroundColor = "#ff9900";
        button.classList.remove("snize-add-to-cart-button");
      }
      if (element.textContent.trim() === "In Stock") {
        element.innerHTML = `
          <span style="color:#00AA00; font-size:14px; font-weight:500;">
            &#10004; In Stock | <small>Ships Fastest</small>
          </span>
        `;
      //button.textContent = "&#10004; View Product"; // Update button text for pre-orders
        button.style.backgroundColor = "#00AA00";
        
      }

      if (element.textContent.trim() === "Unavailable") {
        element.innerHTML = `
          <span style="color:#ff2000; font-size:14px; font-weight:500;">
            Just Missed It.
          </span>
        `;
        button.textContent = "Sold Out"; // Update button text for unavailable items
        button.classList.add("disabled");// Optionally add a disabled class for styling
        button.classList.remove("snize-add-to-cart-button");
        button.setAttribute("disabled", "true"); // Disable the button
        button.style.backgroundColor = "#d3d3d3"; // Change button color for disabled state
        button.style.cursor = "default";
      }
    });
  }

  // Create a MutationObserver to watch for changes in the DOM
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        replaceSpecialOrderText();
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Run the function initially in case some elements are already present
  replaceSpecialOrderText();

  // Select the "Pop Perks" link by matching its text content
    const popPerksLink = Array.from(document.querySelectorAll('a.nav-dropdown__link[data-type="menuitem"]'))
        .find(link => link.textContent.trim() === 'Pop Perks');

    // Check if the "Pop Perks" link exists
    if (popPerksLink) {
        // Add the onclick event handler dynamically
        popPerksLink.setAttribute('onclick', 'triggerRewardsPopup(event)');
    }

});

function triggerRewardsPopup(event) {
    event.preventDefault(); // Prevent the default link behavior
    console.log("Pop Perks Loading");
    window.alert('The rewards link has moved. Look for a trophy in a red circle located in the bottom right corner.');
}

/* ==========================================================================
   Pop Weasel Custom AJAX Add to Cart
   Bypasses theme.js and app fetch-interceptors
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  
  // Helper to find parent form of a clicked button
  function findParentForm(element) {
    return element.closest('form[action*="/cart/add"]');
  }

  // 1. Delegate 'submit' event on the document to catch all current and future forms
  document.addEventListener('submit', function (e) {
    
    // Check if the submitter was one of our specific "pw-add-to-cart" buttons
    // OR if the form itself contains such a button (for generic enter-key submits)
    var form = e.target;
    var submitter = e.submitter; // The button that was clicked

    // If the button clicked doesn't have our custom attribute, we *might* want to let the theme handle it.
    // However, if you want to force ALL product forms to use this, we check the form action.
    var isProductForm = form.action && form.action.includes('/cart/add');
    var isCustomButton = submitter && submitter.getAttribute('data-action') === 'pw-add-to-cart';
    var hasSellingPlanBridge = !!form.querySelector('[data-pw-selling-plan-input]');

    // If it's a product form and matches our custom button (or we just want to hijack all product forms)
    if (isProductForm && (isCustomButton || hasSellingPlanBridge)) {
      
      // STOP THEME.JS
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var btn = submitter || form.querySelector('button[type="submit"], input[type="submit"]');
      var originalText = btn ? btn.innerHTML : '';

      // Visual Feedback: Loading
      if (btn) {
        btn.disabled = true;
        btn.innerHTML = '<span class="pw-spinner"></span> Adding...';
      }
      
      // Prepare Data
      var formData = new FormData(form);
      var payload = {};
      var props = {};

      formData.forEach(function (value, key) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
          payload[key] = value;
        } 
        // Handle properties[Key]
        else if (key.indexOf('properties[') === 0) {
          var m = key.match(/^properties\[(.*)\]$/);
          if (m && m[1]) {
            props[m[1]] = value;
          }
        }
      });

      if (Object.keys(props).length > 0) {
        payload.properties = props;
      }

      if (!payload.selling_plan) {
        var checkedSellingPlan = form.querySelector('.shopify_subscriptions_fieldset input[type="radio"][data-selling-plan-id]:checked');
        if (checkedSellingPlan && checkedSellingPlan.getAttribute('data-selling-plan-id')) {
          payload.selling_plan = checkedSellingPlan.getAttribute('data-selling-plan-id');
        }
      }

      // 2. Perform XHR Request (Bypasses patched Fetch)
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Success
          if (btn) btn.innerHTML = '&#10004; Added';
          
          // 3. Refresh Cart Data
          refreshCartData(function(cart) {
            // Revert button after 2 seconds
            setTimeout(function() {
              if (btn) {
                btn.disabled = false;
                btn.innerHTML = originalText;
              }
            }, 2000);
          });

        } else {
          // Error
          console.error('PW Add-to-cart failed:', xhr.responseText);
          if (btn) btn.innerHTML = 'Error';
          try {
             var resp = JSON.parse(xhr.responseText);
             if(resp.description) alert(resp.description);
          } catch(err) {}
          
          setTimeout(function() {
            if (btn) {
              btn.disabled = false;
              btn.innerHTML = originalText;
            }
          }, 2000);
        }
      };

      xhr.onerror = function () {
        console.error('PW Network Error');
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = originalText;
        }
      };

      xhr.send(JSON.stringify(payload));
    }
  }, true); // Use Capture phase to ensure we run before theme.js bubbling listeners
});

/* ==========================================================================
   Shopify Subscriptions app bridge
   Keeps the native subscription app widget linked to our custom product form.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  function moneyFallback(value) {
    return value || '';
  }

  function getProductForm(target) {
    if (!target) return null;
    if (target.closest) {
      var closestForm = target.closest('form[action*="/cart/add"]');
      if (closestForm) return closestForm;
    }
    if (target.querySelector) {
      var childForm = target.querySelector('form[action*="/cart/add"]');
      if (childForm) return childForm;
    }
    var bridgeInput = document.querySelector('form[action*="/cart/add"] [data-pw-selling-plan-input]');
    return bridgeInput ? bridgeInput.closest('form[action*="/cart/add"]') : null;
  }

  function getSellingPlanData(form) {
    var el = form ? form.querySelector('[data-pw-selling-plan-json]') : null;
    if (!el) return null;
    if (el.__pwSellingPlanData) return el.__pwSellingPlanData;
    try {
      el.__pwSellingPlanData = JSON.parse(el.textContent || '{}');
      return el.__pwSellingPlanData;
    } catch (err) {
      return null;
    }
  }

  function getCurrentVariantId(form) {
    var variantInput = form ? form.querySelector('select[name="id"], input[name="id"]') : null;
    return variantInput ? String(variantInput.value || '') : '';
  }

  function getSelectedPlanId(form, data) {
    var selectedPurchaseOption = form.querySelector('.shopify_subscriptions_fieldset input[type="radio"][data-radio-type]:checked');
    if (
      selectedPurchaseOption &&
      selectedPurchaseOption.getAttribute('data-radio-type') === 'one_time_purchase' &&
      !(data && data.requiresSellingPlan)
    ) {
      return '';
    }

    var checkedRadio = form.querySelector('.shopify_subscriptions_fieldset input[type="radio"][data-selling-plan-id]:checked');
    var dropdown = form.querySelector('.shopify_subscriptions_fieldset select.group_dropdown');
    var hidden = form.querySelector('[data-pw-selling-plan-input]');

    if (checkedRadio && checkedRadio.getAttribute('data-selling-plan-id')) {
      return checkedRadio.getAttribute('data-selling-plan-id');
    }
    if (dropdown && dropdown.value) {
      return dropdown.value;
    }
    if (hidden && hidden.value) {
      return hidden.value;
    }
    return data && data.defaultSellingPlanId ? String(data.defaultSellingPlanId) : '';
  }

  function firstPlanForVariant(variantData) {
    if (!variantData || !variantData.plans) return null;
    var keys = Object.keys(variantData.plans);
    if (!keys.length) return null;
    return { id: keys[0], data: variantData.plans[keys[0]] };
  }

  function isComicSubscriptionProduct(data) {
    return data && String(data.productId || '') === '8507996700863';
  }

  function billingCopy(text) {
    return String(text || '')
      .replace(/Deliver every week/gi, 'Weekly invoices')
      .replace(/Deliver every month/gi, 'Monthly invoices')
      .replace(/Deliver every 2 weeks/gi, 'Fortnightly invoices');
  }

  function relabelBillingCopy(data, scope) {
    if (!isComicSubscriptionProduct(data) || !scope) return;

    scope.querySelectorAll('.shopify_subscriptions_fieldset option').forEach(function (option) {
      option.textContent = billingCopy(option.textContent);
    });

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || parent.closest('script, style')) {
          return NodeFilter.FILTER_REJECT;
        }
        return /Deliver every/i.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });

    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) {
      textNodes.push(node);
    }
    textNodes.forEach(function (textNode) {
      textNode.nodeValue = billingCopy(textNode.nodeValue);
    });
  }

  function updateSubscriptionWidget(form, explicitVariantId) {
    if (!form) return;

    var data = getSellingPlanData(form);
    var hidden = form.querySelector('[data-pw-selling-plan-input]');
    if (!data || !hidden) return;

    var variantId = explicitVariantId ? String(explicitVariantId) : getCurrentVariantId(form);
    var variantData = data.variants ? data.variants[variantId] : null;
    var planId = getSelectedPlanId(form, data);
    var planData = variantData && variantData.plans ? variantData.plans[planId] : null;

    if (!planData && (planId || data.requiresSellingPlan)) {
      var fallbackPlan = firstPlanForVariant(variantData);
      if (fallbackPlan) {
        planId = fallbackPlan.id;
        planData = fallbackPlan.data;
      }
    }

    var appHiddenInputs = form.querySelectorAll('input[name="selling_plan"].selected-selling-plan-id');

    if (planId) {
      hidden.value = planId;
      hidden.disabled = false;
      appHiddenInputs.forEach(function (input) {
        input.value = planId;
        input.disabled = false;
      });
    } else {
      hidden.value = '';
      hidden.disabled = true;
      appHiddenInputs.forEach(function (input) {
        input.value = '';
        input.disabled = true;
      });
    }

    var appBlocks = form.querySelectorAll('.shopify_subscriptions_app_block');
    var hasMatchingBlock = false;

    appBlocks.forEach(function (block) {
      var blockVariantId = String(block.getAttribute('data-variant-id') || '');
      if (!blockVariantId || blockVariantId === variantId) {
        hasMatchingBlock = true;
      }
    });

    appBlocks.forEach(function (block) {
      var blockVariantId = String(block.getAttribute('data-variant-id') || '');
      if (!hasMatchingBlock || !blockVariantId || blockVariantId === variantId) {
        block.style.display = '';
        block.classList.remove('shopify_subscriptions_app_block--hidden');
        block.removeAttribute('aria-hidden');
      } else {
        block.style.display = 'none';
        block.classList.add('shopify_subscriptions_app_block--hidden');
        block.setAttribute('aria-hidden', 'true');
      }
    });

    var activeBlock = form.querySelector('.shopify_subscriptions_app_block[data-variant-id="' + variantId + '"]');
    var priceScope = activeBlock || form;
    relabelBillingCopy(data, priceScope);

    priceScope.querySelectorAll('.shopify_subscriptions_fieldset input[data-radio-type="one_time_purchase"]').forEach(function (radio) {
      var oneTimePrice = moneyFallback(variantData && variantData.price);
      if (variantId) radio.setAttribute('data-variant-id', variantId);
      if (oneTimePrice) radio.setAttribute('data-variant-price', oneTimePrice);
      radio.setAttribute('data-variant-compare-at-price', '');

      var row = radio.closest('.subscription_group') || radio.closest('label') || radio.parentElement;
      var priceEl = row ? row.querySelector('.in_widget_price') : null;
      if (priceEl && oneTimePrice) priceEl.textContent = oneTimePrice;
    });

    priceScope.querySelectorAll('.shopify_subscriptions_fieldset input[type="radio"][data-selling-plan-id]').forEach(function (radio) {
      var radioPlanId = radio.getAttribute('data-selling-plan-id') || planId;
      var radioPlanData = variantData && variantData.plans ? variantData.plans[radioPlanId] : null;
      var radioPrice = moneyFallback(radioPlanData && radioPlanData.price);
      var radioCompareAt = moneyFallback(radioPlanData && radioPlanData.compareAtPrice);

      if (variantId) radio.setAttribute('data-variant-id', variantId);
      if (radioPrice) radio.setAttribute('data-variant-price', radioPrice);
      radio.setAttribute('data-variant-compare-at-price', radioCompareAt);

      var row = radio.closest('.subscription_group') || radio.closest('label') || radio.parentElement;
      var priceEl = row ? row.querySelector('.allocation_price, .in_widget_price') : null;
      if (priceEl && radioPrice) priceEl.textContent = radioPrice;
    });

    priceScope.querySelectorAll('.shopify_subscriptions_fieldset select.group_dropdown').forEach(function (select) {
      if (planId) select.value = planId;
      var selectedPlanPrice = '';
      Array.prototype.forEach.call(select.options || [], function (option) {
        var optionPlanId = String(option.value || '');
        var optionPlanData = variantData && variantData.plans ? variantData.plans[optionPlanId] : null;
        var optionPrice = moneyFallback(optionPlanData && optionPlanData.price);
        var optionCompareAt = moneyFallback(optionPlanData && optionPlanData.compareAtPrice);

        if (optionPrice) option.setAttribute('data-variant-price', optionPrice);
        option.setAttribute('data-variant-compare-at-price', optionCompareAt);

        if (optionPlanId === String(select.value || planId)) {
          selectedPlanPrice = optionPrice;
        }
      });

      var row = select.closest('.subscription_group') || select.parentElement;
      var allocationPrice = row ? row.querySelector('.allocation_price') : null;
      if (allocationPrice && selectedPlanPrice) allocationPrice.textContent = selectedPlanPrice;
    });
  }

  function scheduleSubscriptionWidgetUpdate(form, explicitVariantId) {
    if (!form) return;

    updateSubscriptionWidget(form, explicitVariantId);

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        updateSubscriptionWidget(form, explicitVariantId);
      });
    }

    window.setTimeout(function () {
      updateSubscriptionWidget(form, explicitVariantId);
    }, 0);

    window.setTimeout(function () {
      updateSubscriptionWidget(form, explicitVariantId);
    }, 80);
  }

  document.querySelectorAll('form[action*="/cart/add"] [data-pw-selling-plan-input]').forEach(function (input) {
    scheduleSubscriptionWidgetUpdate(getProductForm(input));
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('.shopify_subscriptions_fieldset input[type="radio"][data-selling-plan-id]') ||
      event.target.matches('.shopify_subscriptions_fieldset select.group_dropdown') ||
      event.target.matches('form[action*="/cart/add"] select[name="id"]') ||
      event.target.matches('.product-form__single-selector')
    ) {
      scheduleSubscriptionWidgetUpdate(getProductForm(event.target));
    }
  });

  document.addEventListener('variant:changed', function (event) {
    var form = getProductForm(event.target);
    var variant = event.detail && event.detail.variant ? event.detail.variant : null;
    scheduleSubscriptionWidgetUpdate(form, variant && variant.id);
  });
});

/* ==========================================================================
   Previously Ordered badges
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  var CUSTOMER_KEY = 'pwPreviouslyOrdered';
  var customerPayload = window.__pwCustomerPreviouslyOrdered || {};
  var customerId = customerPayload && customerPayload.customerId ? String(customerPayload.customerId) : '';
  var history = normalizeHistory(customerPayload ? customerPayload.history : null);
  var productIds = {};
  var variantIds = {};

  if (!customerId) {
    try {
      localStorage.removeItem(CUSTOMER_KEY);
    } catch (err) {}
    return;
  }

  if (history.productIds.length || history.variantIds.length) {
    writeCache(customerId, history);
  } else {
    var cached = readCache(customerId);
    if (cached) {
      history = cached;
    }
  }

  history.productIds.forEach(function (id) {
    productIds[String(id)] = true;
  });

  history.variantIds.forEach(function (id) {
    variantIds[String(id)] = true;
  });

  function normalizeHistory(value) {
    if (!value || typeof value !== 'object') {
      return { productIds: [], variantIds: [], updatedAt: null };
    }

    return {
      productIds: dedupeNumericArray(value.productIds),
      variantIds: dedupeNumericArray(value.variantIds),
      updatedAt: value.updatedAt || null
    };
  }

  function dedupeNumericArray(values) {
    if (!Array.isArray(values)) {
      return [];
    }

    var map = {};
    values.forEach(function (value) {
      var id = parseInt(value, 10);
      if (!isNaN(id) && id > 0) {
        map[String(id)] = id;
      }
    });

    return Object.keys(map).map(function (key) {
      return map[key];
    });
  }

  function readCache(expectedCustomerId) {
    try {
      var raw = localStorage.getItem(CUSTOMER_KEY);
      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);
      if (!parsed || String(parsed.customerId || '') !== String(expectedCustomerId)) {
        return null;
      }

      return normalizeHistory(parsed.history);
    } catch (err) {
      return null;
    }
  }

  function writeCache(id, normalizedHistory) {
    try {
      localStorage.setItem(CUSTOMER_KEY, JSON.stringify({
        customerId: String(id),
        history: normalizedHistory
      }));
    } catch (err) {}
  }

  function hasBeenOrdered(productId, variantId) {
    if (productId && productIds[String(productId)]) {
      return true;
    }

    if (variantId && variantIds[String(variantId)]) {
      return true;
    }

    return false;
  }

  function ensureBadge(target) {
    var badge = target.querySelector('.pw-previously-ordered-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'pw-previously-ordered-badge';
      badge.textContent = 'Previously Ordered';
      target.appendChild(badge);
    }

    badge.hidden = false;
    return badge;
  }

  function applyCollectionBadges(root) {
    (root || document).querySelectorAll('.product-item__image-wrapper[data-product-id]').forEach(function (node) {
      var productId = node.getAttribute('data-product-id') || '';
      var variantId = node.getAttribute('data-variant-id') || '';

      if (hasBeenOrdered(productId, variantId)) {
        ensureBadge(node);
      }
    });
  }

  function applyProductBadge(root) {
    var gallery = (root || document).querySelector('.product-gallery__carousel-wrapper[data-product-id]');
    if (!gallery) {
      return;
    }

    var productId = gallery.getAttribute('data-product-id') || '';
    var variantId = gallery.getAttribute('data-variant-id') || '';

    if (hasBeenOrdered(productId, variantId)) {
      var wrap = gallery.querySelector('.pw-product-gallery-badge-wrap') || gallery;
      ensureBadge(wrap);
    }
  }

  function applyAll(root) {
    applyCollectionBadges(root);
    applyProductBadge(root);
  }

  applyAll(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node && node.nodeType === 1) {
          applyAll(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

/* --- Helper to fetch fresh cart data and update UI --- */
function refreshCartData(callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', '/cart.js', true);
  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      try {
        var cart = JSON.parse(xhr.responseText);

        // Update Header Badge
        var badge = document.querySelector('.pw-cart-badge');
        if (badge) {
          badge.textContent = cart.item_count > 0 ? cart.item_count : '';
        }
        // Update Mobile/Desktop Nav Counts if they exist
        var headerCounts = document.querySelectorAll('.header__cart-count');
        headerCounts.forEach(function(el) {
           el.textContent = cart.item_count > 0 ? cart.item_count : '';
        });

        // Update Custom Sticky Cart
        if (typeof window.pwUpdateStickyCart === 'function') {
          window.pwUpdateStickyCart();
        }

        // Dispatch generic event for other apps
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); // For some themes

        if (callback) callback(cart);

      } catch (e) {
        console.error('Error parsing cart.js', e);
      }
    }
  };
  xhr.send();
}
